var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25134 17.4668C6.25134 18.8665 7.42632 20.0001 8.87698 20.0001C10.3277 20.0001 11.5026 18.8665 11.5026 17.4668",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16164 4.79987C6.17908 4.0082 7.46564 3.5332 8.87692 3.5332C12.1393 3.5332 14.7846 6.08554 14.7846 9.2332V12.2669C14.7846 13.1409 15.2375 13.9579 15.9924 14.4455C16.465 14.7495 16.7538 15.2689 16.7538 15.8199C16.7538 16.7319 15.9858 17.4729 15.0406 17.4729H2.71323C1.768 17.4729 1 16.7319 1 15.8199C1 15.2689 1.28882 14.7559 1.76144 14.4455C2.51631 13.9579 2.96923 13.1409 2.96923 12.2669V9.2332C2.96923 8.3212 3.19241 7.45987 3.58626 6.69987",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90759 3.86267V2.9C6.90759 1.84867 7.78718 1 8.87682 1C9.42164 1 9.91395 1.21533 10.2684 1.55733C10.6229 1.89933 10.8461 2.37433 10.8461 2.9V3.86267",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.4b379daca1d3e15c34510a8fb21001a1.svg";
export { ForwardRef as ReactComponent };